

import Vue from 'vue';
export default Vue.component('MStoreTimeout', {
  props: {
    timeoutSeconds: {
      type: Number,
      required: true
    },
    action: {
      required: true
    }
  },
  data() {
    return {
      timeout: null
    };
  },
  methods: {
    setTimer(this: any) {
      this.timeout = setTimeout(() => {
        this.action();
      }, this.timeoutSeconds * 1000);
    }
  },
  created(this: any) {
    this.setTimer();
  },
  destroyed(this: any) {
    clearTimeout(this.timeout);
  }
});
